<template>
  <LayoutDefault>
    <div
      class="container dark"
      id="subscriptions">
      <template v-if="$auth.ready() && $auth.check()">
        <section class="block">
            <SubscriptionsHistoryTable />
        </section>
        <section class="block" style="display:flex;align-content: space-between;align-items: center;margin: 1rem auto;">
          <div style="flex:1;">
            <router-link
              class="support-link"
              :to="{name: 'support'}">
              {{ $t('zammad_support.link') }}
            </router-link>
          </div>
          <div>
            <a    
              @click="goBackOrHome" class="btn-go-back">&laquo; 
              {{ $t('dashboard.back') }}
            </a>
          </div>
        </section>
      </template>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import SubscriptionsHistoryTable from "../components/SubscriptionsHistoryTable";

export default {
      components: {
        LayoutDefault,
        SubscriptionsHistoryTable
      },
      methods: {
    //VER COMO PASAR ESTO A UN METODO GENERAL!!
    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        // Si hay una ruta anterior almacenada, redirigimos a ella
        this.$router.push(this.$route.meta.previousRoute);
      } else {
        // Si no hay una ruta anterior almacenada, redirigimos al home
        this.$router.push({ name: "home" });
      }
    },
  }
    }
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';
#subscriptions {
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;
}

.block {
  margin:0 auto;
  width: 75%;
}

.support-link {
  &:hover {
    font-weight: bold;
  }
}

.btn-go-back {
  color: var(--pallete_main_color);
  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>